import React from "react";

interface CustomerAvatarProps {
  name: string;
  pattern?: string;
  size?: number;
  className?: string;
}

export const CustomerAvatar: React.FC<CustomerAvatarProps> = ({
  name,
  size = 20,
  className = "",
}) => {
  return (
    <div
      style={{ width: size, height: size }}
      className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#E0EAFF] ${className}`}
    >
      <svg
        width={Math.round(size * 0.75)}
        height={Math.round(size * 0.75)}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C10.5186 13.5 12.6373 11.8037 13.2796 9.47963C13.4074 9.01704 13.0645 8.5625 12.5855 8.5625C12.2132 8.5625 11.897 8.83515 11.8085 9.19694C11.3283 10.9419 9.77884 12.25 8 12.25C5.65279 12.25 3.75 10.3472 3.75 8C3.75 5.65279 5.65279 3.75 8 3.75C9.77884 3.75 11.3283 5.05809 11.8085 6.80306C11.897 7.16485 12.2132 7.4375 12.5855 7.4375C13.0645 7.4375 13.4074 6.98296 13.2796 6.52037C12.6373 4.19633 10.5186 2.5 8 2.5Z"
          fill="#1570EF"
        />
        <circle cx="8" cy="8" r="1.5" fill="#1570EF" />
      </svg>
    </div>
  );
};
